export default __webpack_public_path__ + "static/media/outcess6.aab41a44.jpeg";